import React from "react";
import spinner from "../assets/img/spinner.gif";

const Spinner = ({ text }) => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
      }}
    >
      <img src={spinner} alt="spinner" />
      <span>{text}</span>
    </div>
  );
};

export default Spinner;
